import EditBankAccountContainer from "./EditBankAccountContainer";
export default EditBankAccountContainer;
